import React, { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.scss';
import Routes from './Routes/Routes';
import { Bounce, ToastContainer } from 'react-toastify';
import { LDProvider } from 'launchdarkly-react-client-sdk';
import config from '../config/config';

class App extends Component {
    constructor(props) {
        super(props);

        const env = process.env.BUILD_ENV;
        if (env !== 'production') {
            document.title = `Nexio Dashboard ${env}`;
        }
    }

    render() {
        return (
            <LDProvider
                clientSideID={config.launchDarklyClientId}
                options={{
                    bootstrap: 'localStorage',
                    streaming: true,
                    logger: {
                        error: (...args) => console.error(...args),
                        warn: (...args) => console.warn(...args),
                        info: () => { }, // suppress stream connection logs
                        debug: () => { } // suppress debug logs
                    }
                }}
                timeout={5}
            >
                <div className="emvio-app">
                    <Router>
                        <div className="app-container">
                            <Routes />
                            <ToastContainer
                                autoClose={5000}
                                position="top-center"
                                hideProgressBar={true}
                                newestOnTop={false}
                                icon={false}
                                transition={Bounce}
                                toastClassName="toast-container"
                            />
                        </div>
                    </Router>
                </div>
            </LDProvider>
        );
    }
}

export default App;
